exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes ChangePasswordDialog_fadeIn__6FlTc {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes ChangePasswordDialog_fadeIn__6FlTc {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes ChangePasswordDialog_fadeOut__QIK9A {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ChangePasswordDialog_fadeOut__QIK9A {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.ChangePasswordDialog_content__2UGNd {\n  width: 400px;\n  position: relative; }\n  .ChangePasswordDialog_content__2UGNd .ChangePasswordDialog_hidden__3rviA {\n    opacity: 0; }\n\n.ChangePasswordDialog_message__3OqSO {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"content": "ChangePasswordDialog_content__2UGNd",
	"hidden": "ChangePasswordDialog_hidden__3rviA",
	"message": "ChangePasswordDialog_message__3OqSO",
	"fadeIn": "ChangePasswordDialog_fadeIn__6FlTc",
	"fadeOut": "ChangePasswordDialog_fadeOut__QIK9A"
};